<script>
export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: 'The 404 page.' }],
  },
}
</script>

<template>
  <div>
    404
  </div>
</template>
